<template>
  <div ref="centerBottom2" id="centerBottom2"></div>
</template>

<script>
import * as echarts from 'echarts'
import * as API from '../common/common.js'
export default {
  data() {
    return {
      option: {
        // title: {
        //   text: '2019年销售水量和主营业务收入对比',
        //   textStyle: {
        //     align: 'center',
        //     color: '#fff',
        //     fontSize: 20
        //   },
        //   top: '3%',
        //   left: '10%'
        // },
        // backgroundColor: '#0f375f',
        grid: {
          top: '20%',
          bottom: '13%', //也可设置left和right设置距离来控制图表的大小
          left: '8%',
          right: '8%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        legend: {
          data: ['厂站数量'],
          top: '8%',
          textStyle: {
            color: '#ffffff'
          }
        },
        xAxis: {
          data: [],
          axisLine: {
            show: true //隐藏X轴轴线
            // lineStyle: {
            //   color: '#01FCE3'
            // }
          },
          axisTick: {
            show: true //隐藏X轴刻度
          },
          axisLabel: {
            show: true,
            rotate: 45,
            textStyle: {
              color: '#ebf8ac' //X轴文字颜色
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '个',
            nameTextStyle: {
              color: '#ebf8ac'
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#FFFFFF'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#ebf8ac'
              }
            }
          },
          // {
          //   type: 'value',
          //   name: '同比增长',
          //   nameTextStyle: {
          //     color: '#ebf8ac'
          //   },
          //   position: 'right',
          //   splitLine: {
          //     show: false
          //   },
          //   axisTick: {
          //     show: false
          //   },
          //   axisLine: {
          //     show: false
          //   },
          //   axisLabel: {
          //     show: true,
          //     formatter: '{value} %', //右侧Y轴文字显示
          //     textStyle: {
          //       color: '#ebf8ac'
          //     }
          //   }
          // },
          {
            type: 'value',
            gridIndex: 0,
            min: 50,
            max: 100,
            splitNumber: 8,
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              rotate: 25
            },
            splitArea: {
              show: true,
              areaStyle: {
                color: ['rgba(250,250,250,0.0)', 'rgba(250,250,250,0.05)']
              }
            }
          }
        ],
        series: [
          {
            name: '厂站数量',
            type: 'bar',
            barWidth: 15,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#00FFE3'
                  },
                  {
                    offset: 1,
                    color: '#4693EC'
                  }
                ])
              }
            },
            data: []
          }
          // {
          //   name: '同比增长',
          //   type: 'line',
          //   yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          //   smooth: true, //平滑曲线显示
          //   showAllSymbol: true, //显示所有图形。
          //   symbol: 'circle', //标记的图形为实心圆
          //   symbolSize: 10, //标记的大小
          //   itemStyle: {
          //     //折线拐点标志的样式
          //     color: '#058cff'
          //   },
          //   lineStyle: {
          //     color: '#058cff'
          //   },
          //   areaStyle: {
          //     color: 'rgba(5,140,255, 0.2)'
          //   },
          //   data: []
          // }
        ]
      }
    }
  },
  mounted() {
    this.$watch(
      () => this.option,
      (val) => {
        let myChart = echarts.init(this.$refs.centerBottom2)
        myChart.setOption(val)
      },
      {
        deep: true,
        immediate: true
      }
    )
  },
  created() {
    API.GetDataByMonthlyProduction().then(({ data }) => {
      const arr1 = []
      const arr2 = []
      const arr3 = []
      data.data.forEach((e) => {
        arr1.push(e.shortName)
        arr2.push(Number(e.production) * 10000)
        arr3.push(e.yoY)
      })
      this.option.xAxis.data = arr1
      this.option.series[0].data = arr2
      // this.option.series[1].data = arr3
    })
  }
}
</script>

<style lang="scss" scoped>
#centerBottom2 {
  width: 850px;
  height: 300px;
}
</style>
